import { Component, Watch } from 'vue-property-decorator';
import Superbutton from 'tivigi/src/components/Superbutton/Superbutton'
import SM3Base from '../SM3Base/SM3Base';

import FloatingWindow from 'tivigi/src/components/FloatingWindow/FloatingWindow'

import WithRender from './Topindikatoren.html';

@WithRender
@Component({
    components: { FloatingWindow,  Superbutton }
})
export default class Topindikatoren extends SM3Base {

    spatialUnit: any = null;



    get compareUnits(): Array<any> {
        let result = Array<any>()

        result.push(this.spatialUnit)
        result.push(this.getSpatialUnit("urn:ngsi-ld:Metropolregion:RheinNeckar"))
        result.push(this.getSpatialUnit("urn:ngsi-ld:Staat:Deutschland"))
        

        return result
    }

    
    
}


